
const SET_CREDIT_NOTES= (state, creditNotes) => {
  state.creditNotes = creditNotes;
  state.outDated=false;
};

const UPDATE_CREDIT_NOTES = (state, creditNotes)=>{
  state.creditNotes.push(...creditNotes);
}


const SET_LOADING = (state, loadingState)=>{
  state.loading = loadingState;
}

const INVALIDATE_LIST = (state) =>{
  state.outDated = true;
}

const SET_COUNT = (state, count) =>{
  state.count = count;
}

const SET_PAGES = (state, pages) =>{
  state.pages = pages;
}

const SET_PAGE = (state, page) =>{
  state.page = page;
}

const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const SET_SEARCH = (state, search)=>{
  state.search = search;
}

const RESET_FILTERS = (state)=>{

}

const SET_ORDERNAME_AND_DIRECTION = (state, {orderName, direction})=>{
  state.orderBy.orderName = orderName;
  state.orderBy.direction = direction;
}

const SET_SORT_ICON = (state, icon)=>{
  state.sort_icon =icon;
}

export default {
  SET_MODE,
  SET_CREDIT_NOTES,
  UPDATE_CREDIT_NOTES,
  SET_LOADING,
  INVALIDATE_LIST,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  SET_MODE,
  SET_SEARCH,
  RESET_FILTERS,
  SET_ORDERNAME_AND_DIRECTION,
  SET_SORT_ICON
};
